module.exports = __webpack_public_path__ + "static/media/swapBg.8a101afa.jpg";